import {Component, Input, OnInit} from '@angular/core';

import {LibOptionValue} from 'daisy-design-system-front';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DropdownComponent} from '../../dropdown/dropdown.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {AuthSupportProvider} from "../../../../../swagger-gen/gnvert-secured/models/auth-support-provider";

@Component({
  selector: 'app-select-transaction-provider',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, DropdownComponent, TranslateModule],
  templateUrl: './select-transaction-provider.component.html',
  styleUrls: ['./select-transaction-provider.component.scss']
})
export class SelectTransactionProviderComponent implements OnInit {
  @Input() valueFormControl = new FormControl<AuthSupportProvider | null>(null);
  
  public transactionProviders: LibOptionValue<AuthSupportProvider>[] = [];
  
  constructor(private readonly translate: TranslateService) {}
  
  ngOnInit(): void {
    this.transactionProviders = Object.values(AuthSupportProvider).map(value => ({label: this.translate.instant(value), value: value}))
  }
}
